function debounce(fn, wait) {
  let timeoutId

  return () => {
    clearTimeout(timeoutId)
    timeoutId = window.setTimeout(fn, wait)
  }
}

function normalizeOptions(value) {
  return {
    delay: 200,
    ratio: 1,
    minFontSize: '16px',
    maxFontSize: '500px',
    ...(value || {})
  }
}

function resizeElement(el) {
  if (!(el instanceof HTMLElement)) return

  const ctx = el.__resizeTextContext
  if (!ctx) return

  const size = Math.max(
    Math.min(el.clientWidth / (ctx.ratio * 10), parseFloat(ctx.maxFontSize)),
    parseFloat(ctx.minFontSize)
  )

  el.style.fontSize = `${size}px`
}

function mountResizeText(el, binding) {
  if (!(el instanceof HTMLElement)) return

  const ctx = normalizeOptions(binding.value)
  const handler = debounce(() => resizeElement(el), ctx.delay)
  el.__resizeTextContext = ctx
  el.__resizeTextHandler = handler

  window.addEventListener('resize', handler, { passive: true })
  resizeElement(el)
}

function unmountResizeText(el) {
  if (!(el instanceof HTMLElement)) return

  if (el.__resizeTextHandler) {
    window.removeEventListener('resize', el.__resizeTextHandler)
  }

  delete el.__resizeTextContext
  delete el.__resizeTextHandler
}

export function installResizeText(target) {
  target.directive('resize-text', {
    mounted(el, binding) {
      mountResizeText(el, binding)
    },
    updated(el, binding) {
      unmountResizeText(el)
      mountResizeText(el, binding)
    },
    beforeUnmount(el) {
      unmountResizeText(el)
    }
  })
}
